import React, { useState } from "react";
import { ListActionButtonProps, Aside, IconButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../core/security/SprintAccessRight";
import { DeliveryBucketAccessType } from "../create/common/DeliveryBucketAccessType";
import { DeliveryBucketItem } from "../listing/DeliveryBucketItem";
import { InviteToDeliveryBucketForm } from "./InviteToDeliveryBucketForm";

export const InviteToDeliveryBucketButton: React.FC<ListActionButtonProps<DeliveryBucketItem>> = (
    props: ListActionButtonProps<DeliveryBucketItem>
) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    const openSidebar = () => {
        setIsSidebarOpen(true);
    };

    const isRoleBased = props.item.accessType === DeliveryBucketAccessType.Role;

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiAdmin]}>
            <IconButton
                tooltipContent="Invite"
                id={props.id}
                onClick={openSidebar}
                disabled={isRoleBased}
                iconProps={{ iconName: "AddFriend" }}
            />
            <Aside isOpen={isSidebarOpen} type="form" headerText="Invite" onDismiss={closeSidebar}>
                <InviteToDeliveryBucketForm
                    onSubmit={closeSidebar}
                    onCancel={closeSidebar}
                    deliveryBucketId={props.item.deliveryBucketId}
                />
            </Aside>
        </AuthorizationWrapper>
    );
};
